import React from 'react';
import { Badge } from '../ui/Badge';

interface ServiceTierBadgeProps {
  tierLevel: string | null | undefined;
  className?: string;
}

export const ServiceTierBadge: React.FC<ServiceTierBadgeProps> = ({ 
  tierLevel, 
  className 
}) => {
  const tier = tierLevel || 'standard';
  
  const getVariant = (tier: string) => {
    switch (tier.toLowerCase()) {
      case 'enterprise':
        return 'default';
      case 'comprehensive':
        return 'secondary';
      case 'standard':
        return 'outline';
      case 'quick':
        return 'outline';
      default:
        return 'outline';
    }
  };

  const getGradientClass = (tier: string) => {
    switch (tier.toLowerCase()) {
      case 'enterprise':
        return 'bg-gradient-to-r from-amber-600 to-orange-600 text-white';
      case 'comprehensive':
        return 'bg-gradient-to-r from-purple-600 to-pink-600 text-white';
      case 'standard':
        return 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white';
      case 'quick':
        return 'bg-gradient-to-r from-green-600 to-emerald-600 text-white';
      default:
        return 'bg-gradient-to-r from-gray-600 to-gray-700 text-white';
    }
  };

  return (
    <Badge 
      variant={getVariant(tier)}
      className={`${getGradientClass(tier)} ${className || ''}`}
    >
      {tier.toUpperCase()}
    </Badge>
  );
};